import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { TeamManagerWorkspaceService } from '../../services/team-manager-workspace/team-manager-workspace.service';

@Injectable({ providedIn: 'root' })
export class TeamManagerWorkspaceGuard implements CanActivate {
  constructor(private workspace: TeamManagerWorkspaceService, private router: Router) {}

  async canActivate(): Promise<boolean | UrlTree> {
    const state = await this.workspace.refresh();
    if (!state.enabled) return this.router.parseUrl('/');
    const team = await this.workspace.ensureSelectedTeam();
    if (this.workspace.isSuperadminWorkspace && !team) return this.router.parseUrl('/');
    return this.workspace.state.enabled ? true : this.router.parseUrl('/');
  }
}
